module.exports = __webpack_public_path__ + "img/4.43eda350.jpg";